import { render, staticRenderFns } from "./AssetableCover.vue?vue&type=template&id=72aeac00"
import script from "./AssetableCover.vue?vue&type=script&lang=js"
export * from "./AssetableCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports